<div class="modern-dialog-card" [ngClass]="'theme-' + type">
  <!-- Top Bar with Close Button -->
  <div class="dialog-top-bar">
    <button type="button" class="btn-dialog-close" (click)="close(false)" aria-label="Close dialog">
      <i class="fa fa-times"></i>
    </button>
  </div>

  <div class="dialog-body">
    <!-- Animated Icon Area -->
    <div class="icon-stage">
      <div class="pulse-ring ring-1"></div>
      <div class="pulse-ring ring-2"></div>

      <!-- Error / Warning Icon -->
      <div class="icon-bubble bubble-error" *ngIf="type === 'error' || type === 'warning'">
        <svg viewBox="0 0 24 24" class="status-svg" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="8" x2="12" y2="12"></line>
          <line x1="12" y1="16" x2="12.01" y2="16"></line>
        </svg>
      </div>

      <!-- Success Icon -->
      <div class="icon-bubble bubble-success" *ngIf="type === 'success'">
        <svg viewBox="0 0 24 24" class="status-svg" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
          <polyline points="22 4 12 14.01 9 11.01"></polyline>
        </svg>
      </div>
    </div>

    <!-- Badge Tag -->
    <div class="badge-row">
      <span class="status-badge" [ngClass]="type">
        <i class="fa" [ngClass]="type === 'success' ? 'fa-check-circle' : (isLoginPrompt ? 'fa-user-lock' : 'fa-exclamation-circle')"></i>
        {{ isLoginPrompt ? 'Login Required' : (type === 'success' ? 'Success' : 'Notice') }}
      </span>
    </div>

    <!-- Dialog Title & Message -->
    <h3 class="dialog-headline">
      {{ title || (isLoginPrompt ? 'Please Log In' : (type === 'success' ? 'All Done!' : 'Attention')) }}
    </h3>

    <p class="dialog-message">
      {{ message }}
    </p>

    <p class="dialog-submessage" *ngIf="subMessage">
      {{ subMessage }}
    </p>
    <p class="dialog-submessage" *ngIf="isLoginPrompt && !subMessage">
      Sign in to your account with your mobile number to rate, review, or connect with verified businesses.
    </p>

    <!-- Dialog Action Buttons -->
    <div class="dialog-actions-container">
      <ng-container *ngIf="isLoginPrompt">
        <button type="button" class="btn-action-primary btn-cta-login" (click)="openLogin()">
          <i class="fa fa-sign-in-alt me-2"></i> Log In Now
        </button>
        <button type="button" class="btn-action-secondary" (click)="close(false)">
          Dismiss
        </button>
      </ng-container>

      <ng-container *ngIf="!isLoginPrompt && (type === 'error' || type === 'warning')">
        <button type="button" class="btn-action-primary btn-cta-error" (click)="close(false)">
          Okay, Got It
        </button>
      </ng-container>

      <ng-container *ngIf="!isLoginPrompt && type === 'success'">
        <button type="button" class="btn-action-primary btn-cta-success" (click)="close(true)">
          <i class="fa fa-check me-2"></i> Continue
        </button>
      </ng-container>
    </div>
  </div>
</div>